import React from 'react';

import EventsPage from '../../../../components/EventsPage';

const Events = () => <EventsPage displayByYear enableImageUpload />;

export default Events;
